var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.page.privateequity && (_vm.page.privateequity.text_left_col || _vm.page.privateequity.text_right_col)) ? _c('div', {
    class: {
      'active': _vm.currentPage == 'privateequity-content'
    },
    attrs: {
      "id": "privateequity-content"
    }
  }, [_c('div', {
    staticClass: "section reduced-width"
  }, [_c('div', {
    staticClass: "section__main"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "cols"
  }, [_c('div', {
    staticClass: "col col_main",
    domProps: {
      "innerHTML": _vm._s(_vm.page.privateequity.text_left_col)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col col_extra",
    domProps: {
      "innerHTML": _vm._s(_vm.page.privateequity.text_right_col)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "diagram-container",
    class: {
      'static': _vm.isIE()
    }
  }, [_c('div', {
    staticClass: "circles circles_1"
  }, [_c('div', {
    staticClass: "circles__text"
  }, [_vm._v(_vm._s(_vm.page.privateequity.text_circle_title_1))]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "circles circles_2"
  }, [_c('span', {
    staticClass: "line"
  }, [_c('svg', {
    attrs: {
      "width": "250",
      "height": "3",
      "viewBox": "0 0 250 3",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('defs', [_c('linearGradient', {
    attrs: {
      "id": "grad1",
      "x1": "0",
      "y1": "0",
      "x2": "250",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "stop-color": "#d4e3ec",
      "offset": "0"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "stop-color": "#ee2e22",
      "offset": "1"
    }
  })], 1)], 1), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "0",
      "y1": "0",
      "x2": "250",
      "y2": "0",
      "stroke-width": "3",
      "stroke": "url(#grad1)",
      "stroke-dasharray": "10, 5"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "circles__text"
  }, [_vm._v(_vm._s(_vm.page.privateequity.text_circle_title_2))]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "circles circles_3"
  }, [_c('span', {
    staticClass: "line"
  }, [_c('svg', {
    attrs: {
      "width": "70",
      "height": "3",
      "viewBox": "0 0 70 3",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('defs', [_c('linearGradient', {
    attrs: {
      "id": "grad2",
      "x1": "0",
      "y1": "0",
      "x2": "70",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "stop-color": "#d4e3ec",
      "offset": "0"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "stop-color": "#ee2e22",
      "offset": "1"
    }
  })], 1)], 1), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "0",
      "y1": "0",
      "x2": "70",
      "y2": "0",
      "stroke-width": "3",
      "stroke": "url(#grad2)",
      "stroke-dasharray": "10, 5"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "circles__text"
  }, [_vm._v(_vm._s(_vm.page.privateequity.text_circle_title_3))]), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('div', {
    staticClass: "circles circles_4"
  }, [_c('span', {
    staticClass: "line"
  }, [_c('svg', {
    attrs: {
      "width": "95",
      "height": "3",
      "viewBox": "0 0 95 3",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('defs', [_c('linearGradient', {
    attrs: {
      "id": "grad3",
      "x1": "0",
      "y1": "0",
      "x2": "95",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "stop-color": "#ee2e22",
      "offset": "0"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "stop-color": "#d4e3ec",
      "offset": "1"
    }
  })], 1)], 1), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "0",
      "y1": "0",
      "x2": "95",
      "y2": "0",
      "stroke-width": "3",
      "stroke": "url(#grad3)",
      "stroke-dasharray": "10, 5"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "circles__text"
  }, [_vm._v(_vm._s(_vm.page.privateequity.text_circle_title_4))]), _vm._v(" "), _vm._m(3)]), _vm._v(" "), _c('div', {
    staticClass: "circles circles_5"
  }, [_c('span', {
    staticClass: "line"
  }, [_c('svg', {
    attrs: {
      "width": "170",
      "height": "3",
      "viewBox": "0 0 170 3",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('defs', [_c('linearGradient', {
    attrs: {
      "id": "grad4",
      "x1": "0",
      "y1": "0",
      "x2": "170",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "stop-color": "#ee2e22",
      "offset": "0"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "stop-color": "#d4e3ec",
      "offset": "1"
    }
  })], 1)], 1), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "0",
      "y1": "0",
      "x2": "170",
      "y2": "0",
      "stroke-width": "3",
      "stroke": "url(#grad4)",
      "stroke-dasharray": "10, 5"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "circles__text"
  }, [_vm._v(_vm._s(_vm.page.privateequity.text_circle_title_5))]), _vm._v(" "), _vm._m(4)]), _vm._v(" "), _c('div', {
    staticClass: "circles circles_6"
  }, [_c('span', {
    staticClass: "line"
  }, [_c('svg', {
    attrs: {
      "width": "360",
      "height": "3",
      "viewBox": "0 0 360 3",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('defs', [_c('linearGradient', {
    attrs: {
      "id": "grad5",
      "x1": "0",
      "y1": "0",
      "x2": "360",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "stop-color": "#ee2e22",
      "offset": "0"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "stop-color": "#d4e3ec",
      "offset": "1"
    }
  })], 1)], 1), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "0",
      "y1": "0",
      "x2": "360",
      "y2": "0",
      "stroke-width": "3",
      "stroke": "url(#grad5)",
      "stroke-dasharray": "10, 5"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "circles__text"
  }, [_vm._v(_vm._s(_vm.page.privateequity.text_circle_title_6))]), _vm._v(" "), _vm._m(5)])]), _vm._v(" "), _c('div', {
    staticClass: "benefits"
  }, [_c('div', {
    staticClass: "benefits__title",
    domProps: {
      "innerHTML": _vm._s(_vm.page.privateequity.text_benefits_title)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "cols"
  }, [_c('div', {
    staticClass: "col col_main",
    domProps: {
      "innerHTML": _vm._s(_vm.page.privateequity.text_benefits_left_col)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col col_extra",
    domProps: {
      "innerHTML": _vm._s(_vm.page.privateequity.text_benefits_right_col)
    }
  })])])])])])]) : _vm._e()
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "circles__container"
  }, [_c('div', {
    staticClass: "circle"
  }), _vm._v(" "), _c('div', {
    staticClass: "circle"
  }), _vm._v(" "), _c('div', {
    staticClass: "circle"
  }), _vm._v(" "), _c('div', {
    staticClass: "circle"
  }), _vm._v(" "), _c('div', {
    staticClass: "circle"
  })])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "circles__container"
  }, [_c('div', {
    staticClass: "circle"
  }), _vm._v(" "), _c('div', {
    staticClass: "circle"
  }), _vm._v(" "), _c('div', {
    staticClass: "circle"
  }), _vm._v(" "), _c('div', {
    staticClass: "circle"
  }), _vm._v(" "), _c('div', {
    staticClass: "circle"
  })])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "circles__container"
  }, [_c('div', {
    staticClass: "circle"
  }), _vm._v(" "), _c('div', {
    staticClass: "circle"
  }), _vm._v(" "), _c('div', {
    staticClass: "circle"
  }), _vm._v(" "), _c('div', {
    staticClass: "circle"
  }), _vm._v(" "), _c('div', {
    staticClass: "circle"
  })])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "circles__container"
  }, [_c('div', {
    staticClass: "circle"
  }), _vm._v(" "), _c('div', {
    staticClass: "circle"
  }), _vm._v(" "), _c('div', {
    staticClass: "circle"
  }), _vm._v(" "), _c('div', {
    staticClass: "circle"
  }), _vm._v(" "), _c('div', {
    staticClass: "circle"
  })])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "circles__container"
  }, [_c('div', {
    staticClass: "circle"
  }), _vm._v(" "), _c('div', {
    staticClass: "circle"
  }), _vm._v(" "), _c('div', {
    staticClass: "circle"
  }), _vm._v(" "), _c('div', {
    staticClass: "circle"
  }), _vm._v(" "), _c('div', {
    staticClass: "circle"
  })])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "circles__container"
  }, [_c('div', {
    staticClass: "circle"
  }), _vm._v(" "), _c('div', {
    staticClass: "circle"
  }), _vm._v(" "), _c('div', {
    staticClass: "circle"
  }), _vm._v(" "), _c('div', {
    staticClass: "circle"
  }), _vm._v(" "), _c('div', {
    staticClass: "circle"
  })])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-74c9181e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/PrivateEquityContent.vue
// module id = 199
// module chunks = 0